<template>
  <div>
    <h1>Выберите отчет</h1>
    <Divider>Кассовые отчеты</Divider>
    <Row style="margin-top: 30px; text-align: center">
      <Col span="8">

<!--        <Button type="text" size="large">-->
<!--          <router-link :to="{ name: 'report_shift' }"-->
<!--            >Сменные отчеты</router-link-->
<!--          >-->
<!--        </Button>-->
        <Card
          class="button_card"
          @click.native="
            $router.push({ name: 'report_shift' })
          "
        >
          <div
            style="text-align:center; margin: 25px 0;color: rgba(0, 121, 189, 0.93);"
          >
            <h2>Сменные отчеты</h2>
          </div>
        </Card>


      </Col>
      <Col span="8">
<!--        <Button type="text" size="large">-->
<!--          <router-link :to="{ name: 'report_ticket_history' }"-->
<!--            >История чеков</router-link-->
<!--          >-->
<!--        </Button>-->

        <Card
          class="button_card"
          @click.native="
            $router.push({ name: 'report_ticket_history' })
          "
        >
          <div
            style="text-align:center; margin: 25px 0;color: rgba(0, 121, 189, 0.93);"
          >
            <h2>История чеков</h2>
          </div>
        </Card>

      </Col>
      <Col span="8">
<!--        <Button type="text" size="large">-->
<!--          <router-link :to="{ name: 'report_period_report' }"-->
<!--            >Отчеты за период</router-link-->
<!--          >-->
<!--        </Button>-->

        <Card
          class="button_card"
          @click.native="
            $router.push({ name: 'report_period_report' })
          "
        >
          <div
            style="text-align:center; margin: 25px 0;color: rgba(0, 121, 189, 0.93);"
          >
            <h2>Отчеты за период</h2>
          </div>
        </Card>

      </Col>
    </Row>
    <!--    <Divider></Divider>-->
    <!--    <Row style="margin-top: 30px">-->
    <!--      <Col span="8"-->
    <!--        ><Button type="text" size="large" icon="ios-cart"-->
    <!--          >Отчет по продажам</Button-->
    <!--        ></Col-->
    <!--      >-->
    <!--      <Col span="8"-->
    <!--        ><Button type="text" size="large" icon="ios-cash"-->
    <!--          >Финансовый отчет</Button-->
    <!--        ></Col-->
    <!--      >-->
    <!--    </Row>-->
  </div>
</template>

<script>
export default {
  name: "report"
};
</script>

<style scoped>
  .button_card {
    /*width: 100%;*/
    max-width: 400px;
    background-color: rgba(143, 208, 245, 0.27);
    min-height: 100px;
    cursor: pointer;
    /*margin: 10px*/
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/apps/report/report.vue